export const faqs = [
  {
    question: "Comment trouver un bon marabout à La Réunion ?",
    answer: "Pour trouver un bon marabout à La Réunion, vérifiez l'expérience du praticien et les résultats obtenus. Maître Diamma, avec des années d'expérience, est reconnu comme l'un des meilleurs marabouts du 974. Contactez-le pour une première consultation gratuite."
  },
  {
    question: "Combien de temps pour un retour affectif à La Réunion ?",
    answer: "Avec Maître Diamma, marabout spécialiste du retour affectif à La Réunion, les résultats sont généralement visibles entre 7 et 21 jours selon la complexité de la situation. Certains cas urgents peuvent être traités plus rapidement. Chaque situation est unique et fait l'objet d'une analyse personnalisée."
  },
  {
    question: "Est-ce que les rituels de marabout sont efficaces ?",
    answer: "L'efficacité d'un marabout dépend de son expérience, de ses dons et de la puissance de ses rituels. Maître Diamma affiche un taux de réussite de 99% sur les retours affectifs à La Réunion."
  },
  {
    question: "Maître Diamma se déplace-t-il dans toute La Réunion ?",
    answer: "Oui, Maître Diamma intervient dans toute La Réunion : Saint-Denis, Saint-Pierre, Le Tampon, Saint-Paul, Saint-Louis, Saint-André, Le Port, et toutes les autres communes du 974. Il propose également des consultations par téléphone et WhatsApp pour les personnes ne pouvant pas se déplacer."
  },
  {
    question: "Comment reconnaître un vrai marabout à La Réunion ?",
    answer: "Un vrai marabout comme Maître Diamma se reconnaît par des années d'expérience, sa discrétion, et son honnêteté sur les délais de résultat. Méfiez-vous des promesses de résultats en 24h ou des demandes d'argent importantes à l'avance."
  },
  {
    question: "Peut-on faire un retour affectif à distance ?",
    answer: "Oui, Maître Diamma réalise des rituels de retour affectif à distance depuis La Réunion. Que votre ex soit en métropole, à l'étranger ou ailleurs dans le monde, les rituels africains ancestraux de Maître Diamma sont efficaces sans limite de distance géographique."
  },
  {
    question: "Quel est le prix d'une consultation marabout à La Réunion ?",
    answer: "Les tarifs varient selon les services demandés. Maître Diamma propose une première consultation téléphonique gratuite pour évaluer votre situation. Les rituels sont ensuite adaptés à votre budget avec possibilité de paiement après résultat pour certains travaux."
  },
  {
    question: "Le marabout peut-il aider pour le désenvoûtement ?",
    answer: "Oui, Maître Diamma est expert en désenvoûtement à La Réunion. Si vous êtes victime d'un mauvais sort, d'une malédiction ou d'un envoûtement, il peut vous libérer grâce à des rituels de purification puissants. Un diagnostic gratuit est proposé pour identifier la source de vos problèmes."
  }
];
